import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { Student } from '@ascschool/model/school/student.model';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { QualificationService } from '@ascschool/services/category/qualification.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TransferStaffService } from '@ascschool/services/transfer/transferstaff.service';
import { TypeOfPersonnelService } from '@ascschool/services/category/type-of-personnel.service';
import { PositionService } from '@ascschool/services/category/position.service';
import { PositionGVService } from '@ascschool/services/category/position-gv.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
@Component({
    selector: 'nhan-su-cua-cs',
    templateUrl: './nhan-su-cua-cs.component.html',
    styleUrls: ['./nhan-su-cua-cs.component.scss']
})
export class NhanSuCuaCsComponent implements OnInit {

    isResizdePopup: boolean;
    titlePopup: string;
    @ViewChild('tplTitle', { static: false }) titlePopupElement;
    total: number = 0;
    firstRowOnPage: any;
    searchAdvanced = false;
    divisibleForFour: boolean;
    checkedAll: boolean = false;

    getTypeOfPersonnelACFn: (value: any) => Observable<any>;
    TypeOfPersonnelSubscription: any;
    TypeOfPersonnelControl = new FormControl();

    getPositionACFn: (value: any) => Observable<any>;
    PositionSubscription: any;
    PositionControl = new FormControl();

    getPositionGVACFn: (value: any) => Observable<any>;
    PositionGVSubscription: any;
    PositionGVControl = new FormControl();

    getProvinceACFn: (value: any) => Observable<any>; ProvinceSubscription: any; provinceControl = new FormControl();
    getDistrictACFn: (value: any) => Observable<any>; DistrictSubscription: any; districtControl = new FormControl();
    getSchoolACFn: (value: any) => Observable<any>; SchoolSubcription: any; SchoolControl = new FormControl();
    getQualification: (value: any) => Observable<any>; QualificationSubscription: any; QualificationControl = new FormControl();
    listStudent: Student[];
    listStudentSelected: number[];
    constructor(
        private modal: NzModalRef, private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
        public sizePageService: SizePageService, private authQuery: AuthQuery,
        private service: TransferStaffService, public utilService: UtilsService,
        private TypeOfPersonnelService: TypeOfPersonnelService, private QualificationService: QualificationService,
        private PositionService: PositionService, private PositionGVService: PositionGVService,
        private provinceService: ProvinceService, private districtService: DistrictService, private schoolService: SchoolService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    }
    get breadcrumbs(): string[] {
        return ['Chuyển cơ sở nhân sự'];
    }
    // tslint:disable-next-line: adjacent-overload-signatures
    @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
        if (content2) {
            // initially setter gets called with undefined
            this.elementPageHeaderTable = content2;
        }
    }
    @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
    @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
    private elementPageHeaderTable: ElementRef;
    currentUser: any;
    buttonTypeEnum = ButtonType;
    btnType: ButtonType;
    shortcuts: ShortcutInput[] = [];
    commonFilter = new CommonFilter();
    searchTerm: string = '';
    pageIndex: number = 1;
    categoryModel = new CategoryModel();
    pageSizeOptions: number[] = [50, 100, 200];
    pageSize: number = this.pageSizeOptions[1];

    loading: boolean = true;
    width: number;
    numberControl: number;
    show = false;
    maxHeight: number;
    height: number;
    heightPopup: number;
    heightPagnagation: number = 50;
    isCollapse = true;
    dateFormat = 'dd/MM/yyyy';
    fromDate: any;
    toDate: any;
    sortNameFn = (a, b) => a.fullName.localeCompare(b.fullName);
    ngOnInit() {
        this.commonFilter.PageIndex = 1;
        this.commonFilter.PageSize = this.pageSizeOptions[1];
        this.reload();
        this.maxHeight = window.innerHeight;
        this._authService.getNavChangeEmitter().subscribe(() => {
            this.checkCaculateHeight();
        });
        this.authQuery.userSetting$.subscribe(type => {
            if (type) {
                this.btnType = type.btnType;
            }
        });
        this.loadTypeOfPersonnel();
        this.loadQualification();
        this.loadPositionGV();
        this.loadPosition();
        this.loadProvince();
        if (this.isCollapse) {
            this.divisibleForFour = this.isDivisibleForFour(4);
        } else {
            this.divisibleForFour = this.isDivisibleForFour(12);
        }
    }
    reload() {
        this.loading = true;
        this.checkedAll = false;
        this.service.getStaByEatos(this.commonFilter).subscribe((response: any) => {
            this.total = (response && response.rowCount) ? response.rowCount : 0;
            this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
            this.listStudent = response.results ? response.results : [];
            this.loading = false;
            this.listStudent.map(x => x.checked = false);
            this.listStudentSelected = [];
        }, () => {
            this.listStudent = [];
            this.listStudentSelected = [];
            this.loading = false;
        });
    }
    search() {
        this.commonFilter.PageIndex = 1;
        this.reload();
    }

    pageIndexEvent(pageE: any) {
        this.commonFilter.PageIndex = pageE;
        this.pageIndex = pageE;
        this.reload();
    }
    pageSizeEvent(pageE: any) {
        this.commonFilter.PageSize = pageE;
        this.pageSize = pageE;
        this.reload();
    }
    ngAfterViewInit() {
        this.checkCaculateHeight(this.isCollapse);

        // this.shortcuts.push({
        //   key: ["alt + n"], label: "Help", description: "Cmd + b",
        //   command: () => this.PopupAdd(), preventDefault: true
        // });
        this.cdRef.detectChanges();
    }
    isDivisibleForFour(index: number) {
        if (index % 4 === 0) {
            return true;
        } else {
            return false;
        }
    }

    data: any;
    ChooseData(data: any) {
        this.data = data;
        this.close();
    }

    checkCaculateHeight(isOpen?: boolean) {
        setTimeout(() => {
            this.height = this.heightfnc();
            this.width = this.widthfnc();
        }, 1);
    }
    heightfnc() {
        return this.sizePageService.caculateHeight(
            this.elementpageOptionBtnGroup,
            this.elementPageSearch,
            this.elementPageHeaderTable,
            this.heightPagnagation);
    }
    widthfnc() {
        return this.sizePageService.caculateWidth(this.elementPageSearch);
    }
    caculateHeightPopup(maxHeight: number): number {
        let heightModal: number;
        if (maxHeight > 950) {
            return (heightModal = 700 + (maxHeight - 860));

        } else {
            return (heightModal = 700 - (860 - maxHeight));
        }
    }
    onResize() {
        this.width = this.widthfnc();
        this.checkCaculateHeight(this.isCollapse);
    }
    handleChange(info: NzUploadChangeParam): void {
        if (info.file.status !== 'uploading') {
        }
        if (info.file.status === 'done') {
            this.msg.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
            this.msg.error(`${info.file.name} file upload failed.`);
        }
    }
    toggleCollapse(): void {
        this.maxHeight = window.innerHeight;
        this.isCollapse = !this.isCollapse;
        this.checkCaculateHeight(this.isCollapse);
    }
    resetForm(): void {
    }

    notification(response) {
        if (response.statusCode === 0) {
            this.msg.success('Cập nhật thông tin ' + response.message);
        } else {
            this.msg.error('Lỗi: ' + response.message);
        }
    }
    close() {
        this.destroyModal();
    }
    destroyModal(): void {
        this.modal.destroy(this.data);
    }
    clear() {
        this.commonFilter.FromDate = '';
        this.fromDate = '';
        this.commonFilter.ToDate = '';
        this.toDate = '';
        this.commonFilter.StudentCode = '';
        this.commonFilter.FullName = '';
        delete this.commonFilter.YearOfBirth;
        delete this.commonFilter.Gender;
        this.TypeOfPersonnelControl.setValue(null);
        this.commonFilter.TransferReason = '';
        this.reload();
    }

    valueIfHas(control: FormControl) {
        if (control.value && typeof control.value != 'string') { return control.value.id; }
        return '';
    }

    loadProvince() {
        // tslint:disable-next-line: max-line-length
        this.getProvinceACFn = (value: any) => this.provinceService.getProvinceSelectPaging({
            searchTerm: value, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.ProvinceSubscription) {
            this.ProvinceSubscription = this.provinceControl.valueChanges.subscribe(() => {
                this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.provinceControl.value);
            });
        }
    }
    changeProvince(control: FormControl) {
        this.provinceControl = control;
        if (this.provinceControl) {
            this.loadDistrict();
        } else {
            this.districtControl.setValue(null);
            this.SchoolControl.setValue(null);
        }
    }
    loadQualification() {
        // tslint:disable-next-line: max-line-length
        this.getQualification = (value: any) => this.QualificationService.getSelectPaging({
          searchTerm: value, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.qualificationName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.QualificationSubscription) {
          this.QualificationSubscription = this.QualificationControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'QualificationId', this.QualificationControl.value);
          });
        }
      }
      changeQualification(control: FormControl) {
        this.QualificationControl = control;
      }
    loadDistrict() {
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
            searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
            if (!this.DistrictSubscription) {
                this.DistrictSubscription = this.districtControl.valueChanges.subscribe(() => {
                    this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.districtControl.value);
                });
            }
    }

    changeDistrict(control: FormControl) {
        this.districtControl = control;
        if (this.districtControl) {
            this.loadSchool();
        } else {
            this.SchoolControl.setValue(null);
        }
    }

    loadSchool() {
        this.getSchoolACFn = (value: any) => this.service.getEatos({
            searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), DistrictId: this.valueIfHas(this.districtControl), PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
            if (!this.SchoolSubcription) {
                this.SchoolSubcription = this.SchoolControl.valueChanges.subscribe(() => {
                    this.utilService.bindOrUnBindTheId(this.commonFilter, 'EatosId', this.SchoolControl.value);
                });
            }
    }
    changeSchool(control: FormControl) {
        this.SchoolControl = control;
    }


    loadTypeOfPersonnel() {
        this.getTypeOfPersonnelACFn = (value: any) => this.TypeOfPersonnelService.getSelectPaging({
            searchTerm: value, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.typeOfPersonnelName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.TypeOfPersonnelSubscription) {
            this.TypeOfPersonnelSubscription = this.TypeOfPersonnelControl.valueChanges.subscribe(() => {
                this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfPersonnelId', this.TypeOfPersonnelControl.value);
            });
        }

    }
    changeTypeOfPersonnel(control: FormControl) {
        this.TypeOfPersonnelControl = control;
    }
    loadPosition() {
        this.getPositionACFn = (value: any) => this.PositionService.getSelectPaging({
            searchTerm: value, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.positionName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.PositionSubscription) {
            this.PositionSubscription = this.PositionControl.valueChanges.subscribe(() => {
                this.utilService.bindOrUnBindTheId(this.commonFilter, 'PositionId', this.PositionControl.value);
            });
        }
    }

    changePosition(control: FormControl) {
        this.PositionControl = control;
    }

    loadPositionGV() {
        this.getPositionGVACFn = (value: any) => this.PositionGVService.getSelectPaging({
            searchTerm: value, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.positionGVName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.PositionGVSubscription) {
            this.PositionGVSubscription = this.PositionGVControl.valueChanges.subscribe(() => {
                this.utilService.bindOrUnBindTheId(this.commonFilter, 'PositionGVId', this.PositionGVControl.value);
            });
        }
    }
    changePositionGV(control: FormControl) {
        this.PositionGVControl = control;
    }




    checked = false;
    indeterminate = false;
    listOfCurrentPageData: Student[] = [];
    setOfCheckedId = new Set<number>();
    updateCheckedSet(id: number, checked: boolean): void {
        if (checked) {
            this.setOfCheckedId.add(id);
        } else {
            this.setOfCheckedId.delete(id);
        }
    }
    onItemChecked(id: number, checked: boolean): void {
        this.updateCheckedSet(id, checked);
        this.refreshCheckedStatus();
    }
    onAllChecked(value: boolean): void {
        this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
        this.refreshCheckedStatus();
    }

    onCurrentPageDataChange($event: Student[]): void {
        this.listOfCurrentPageData = $event;
        this.refreshCheckedStatus();
    }

    refreshCheckedStatus(): void {
        this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
        this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
    }
}
